import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Buffer } from "buffer";
import i18n from "./i18n";
import "./App.css";

import NavBar from "./components/Navbar/navBar"; // DEPRECATION: Remove when legacy version is fully replaced
import AppRoutes from "./routes/AppRoutes";
import useIsMobile from "./hooks/useIsMobile";
import { useLocation } from "react-router-dom";

// Polifill for Buffer if needed by some legacy dependencies
global.Buffer = Buffer;

function App() {
  const { t } = useTranslation();
  const location = useLocation();
  const isMobile = useIsMobile();
  const [modal, setModal] = useState(null);

  // Initialize language
  useEffect(() => {
    i18n.changeLanguage("es");
  }, []);

  // Legacy support for password update modal
  const handlePasswordUpdate = () => {
    console.log("Password update triggered");
  };

  const NameCustomer = t("cover_start_login_customer");
  // Only hide nav on the new premium /dashboard sub-routes (exact match or /dashboard/...) but NOT on /dashboard-legacy
  const isDashboardPage = location.pathname === "/dashboard" || location.pathname.startsWith("/dashboard/");
  const isAuthPage = location.pathname === "/" ||
    location.pathname === "/auth/forgot-password" ||
    location.pathname === "/auth/signup" ||
    location.pathname === "/auth/welcome" ||
    location.pathname === "/auth/complete-profile";

  return (
    <div
      className="col-12 d-md-flex"
      style={{
        height: "100vh",
        backgroundColor: "#FFFFFF"
      }}
    >
      {modal}

      {/* DEPRECATION: Remove NavBar and its conditional logic when legacy version is gone */}
      {!isMobile && !isAuthPage && !isDashboardPage && (
        <NavBar
          path={"Nav"}
          typeCustomer={NameCustomer}
          handlePasswordUpdate={handlePasswordUpdate}
        />
      )}

      <div className="flex-grow-1 w-100 d-flex flex-column">
        <React.Suspense fallback={<div className="loading-screen">Cargando...</div>}>
          <AppRoutes elevvaT={t} />
        </React.Suspense>
      </div>
    </div>
  );
}

export default App;
